import { useEffect, useState } from 'react';
import { useForgotPasswordMutation } from 'services/auth/auth.endpoint';
import { useNavigate } from 'react-router-dom';
export const useForgotPasswordVM = () => {
    const navigate = useNavigate();
    const [forgotPasswordErrorMessage, setForgotPasswordErrorMessage] = useState('');
    const [forgotPasswordMode, setForgotPasswordMode] = useState<'form' | 'success'>('form');

    const [
        forgotPassword,
        {
            isLoading: forgotPasswordLoading,
            isError: forgotPasswordError,
            isSuccess: forgotPasswordSuccess,
            error: forgotPasswordResponseError,
            data: forgotPasswordResponse
        }
    ] = useForgotPasswordMutation();

        const handleForgotPassword = async (email: string) => {
        await forgotPassword({
            email
        });
    };  

    const handleBackToLogin = () => {
        navigate('/login');
    };

    useEffect(() => {
        if (forgotPasswordLoading) return;
        if (forgotPasswordError && forgotPasswordResponseError) {
            if ('data' in forgotPasswordResponseError) {
                const errorData = forgotPasswordResponseError.data as { message: string };
                setForgotPasswordErrorMessage(errorData.message);
            } else {
                setForgotPasswordErrorMessage('Une erreur est survenue');
            }
            return;
        }
        if (forgotPasswordSuccess && forgotPasswordResponse) {
            setForgotPasswordErrorMessage('');
            setForgotPasswordMode('success');
            return;
        }
    }, [forgotPasswordLoading, forgotPasswordError, forgotPasswordSuccess, forgotPasswordResponseError, forgotPasswordResponse]);

    return {
        handleForgotPassword,
        forgotPasswordErrorMessage,
        forgotPasswordMode,
        handleBackToLogin
    };
};
